import { parseUtcTimestamp } from '@utils/bmtCancellationsUtcTimestamp';

export default function normalize(data) {
    return {
        gstOrderNumber: data.gstOrderNumber,
        hotelReservationNumber: data.hotelReservationNumber,
        tmOrderNumber: data.tmOrderNumber,
        status: data.status,
        // Timestamps arrive as UTC without a zone designator and are displayed as dates
        // in the viewer's own timezone, so they are parsed into instants here.
        orderDate: parseUtcTimestamp(data.orderDate),
        cancellationDate: parseUtcTimestamp(data.cancellationDate),
        // A plain calendar date carries no timezone, so it is left as it arrives.
        checkIn: data.checkInDate,
        bookingTotal: data.bookingTotal,
        hotelCost: data.hotelCost,
        hotelCostLocal: data.hotelCostLocal,
        cancellationPolicies: data.cancellationPolicies || [],
        cancellationReason: data.cancellationReason,
        cancellationUserInput: data.cancellationUserInput,
        // Two currencies, because the amounts are not all denominated the same way:
        // the booking total is in the order's currency, the hotel costs in the
        // supplier's. partner_price_local has no stored currency at all.
        currency: data.currency,
        partnerCurrency: data.partnerCurrency,
    };
}
